/* ==========================================================================
   Image > Client > Config
   ========================================================================== */

/* Modules */

/* Config */
const config = {
    component: 'Image',
    init: true,
    autoplay: false,
    delay: 3000,
    loops: 1,
    resize: {
        operation: 'resize',
        suboperation: 'crop',
        width: 200,
        height: 200,
        quality: 97
    },
    disableLazy: false,
    image: {
        lazy: '/comun/images/shim.gif'
    },
    css: {
        withBackground: 'image--with-background',
        isVertical: 'image--is-vertical'
    }
};

/* Export */
module.exports = () => config;
